import { 
    MessageResponseDto, 
    GetServiceDto, 
    CreateServiceDto, 
    EditServiceDto,
    UtilServiceControllerGet200Response,
    UtilityServiceApiFp,
    DeleteServiceDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseServiceModel = UtilServiceControllerGet200Response;
export type GetServiceModel = GetServiceDto;
export type MutateResponseServiceModel = MessageResponseDto;
export type CreateServiceModel = CreateServiceDto;
export type UpdateServiceModel = EditServiceDto;
export type DeleteServiceModel = DeleteServiceDto;

export const apiServiceFp =  UtilityServiceApiFp(apiConfig);
export const getServiceController = apiServiceFp.utilServiceControllerGet;
export const createServiceController = apiServiceFp.utilServiceControllerCreate;
export const updateServiceController = apiServiceFp.utilServiceControllerEdit;
export const deleteServiceController = apiServiceFp.utilServiceControllerDelete;

export const QueryKeyService = QueryKey.Service;